import { Controller } from "@hotwired/stimulus"

import { getOptions } from "../helpers/select2.js"

export default class extends Controller {
  static targets = [ "select" ]
  
  hide(event) {
    if (event.currentTarget.checked) {
      $(event.currentTarget.dataset.value).hide()
    } else {
      $(event.currentTarget.dataset.value).show()
    }
  }

  trigger(event) {
    let new_vals = event.currentTarget.dataset.value.split('_')

    let vals = $(this.selectTarget).val()
    if (event.currentTarget.checked) {
      new_vals.forEach(function(value){
        if (vals.indexOf(value)==-1) vals.push(value)
      })
    } else {
      vals = vals.filter(n => !new_vals.includes(n))
    }

    $(this.selectTarget).val(vals)
    $(this.selectTarget).trigger('change')
  }

}
